import axios from 'axios';

export const SrxFsApi = axios.create({
    baseURL: process.env.REACT_APP_FS_SERVER_ENV === 'prod' ? `${process.env.REACT_APP_SRX_FS_SERVER_URL_PROD}` : `${process.env.REACT_APP_SRX_FS_SERVER_URL_DEV}`
})